import { UserName } from '@festina-life/components'
import { dateUtils } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'
import { withSuspense } from '@festina-life/ui/libs'
import { Icon } from '@festina-life/ui/structure'
import cx from 'classnames'

import type { UserActionData } from '../../uiModels/types'
import { UserActionIcon } from './types'

type Props = UserActionData & {
  variant?: 'compact' | 'full'
}

const UserActionInternal = ({
  action,
  userId,
  actionTime,
  variant = 'full',
}: Props) => {
  const translate = useTranslate()
  const iconName = UserActionIcon[action]
  return (
    <div
      className={cx('flex items-center gap-2 flex-wrap w-full', {
        'text-slate-300 dark:text-slate-600':
          action === 'approve' && !actionTime,
        'text-success-500': action === 'approve' && actionTime,
      })}
    >
      <Icon name={iconName} color="unset" />
      {variant === 'full' && (
        <div>{actionTime ? dateUtils.dateWithTimeAsStr(actionTime) : '-'}</div>
      )}
      <div className="wrap-break-word whitespace-normal min-w-0 flex-1">
        {userId ? (
          <UserName userId={userId} showIcon={false} />
        ) : (
          translate('operationStatus.user.unknown')
        )}
      </div>
    </div>
  )
}

export const UserAction = withSuspense(UserActionInternal)
